import { createApp } from 'vue'
import { initRemRoot } from '@/assets/js/remRoot'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import lazyPlugin from 'vue3-lazy'
import loadingDirective from '@/components/base/loading/directive'
import '@/assets/scss/index.scss'
import { createPinia } from 'pinia'
import { ElSlider } from 'element-plus'
import 'element-plus/es/components/slider/style/css'
import { touchDoubleTap } from '@/assets/js/touchDoubleTap.js'
import SvgIcon from '@/components/base/icon/SvgIcon.vue'
import '@/assets/icons/index.js'
// toast start
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css' // 必须引入样式文件
// toast end
import i18n from './i18n'
import { initFirebaseAnalytics } from '@/assets/js/firebase'
import '@/assets/js/fb-pixel'
import 'aws-amplify/auth/enable-oauth-listener'
import { configureAmplify } from '@/service/amplifyAuth'
import { ensureDeviceId } from '@/assets/js/device.js'
import { initInstallChannel } from '@/assets/js/installChannel'
import { initSecuritySignals } from '@/assets/js/securitySignals'

initRemRoot()
configureAmplify()
ensureDeviceId()
initInstallChannel()

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_BUILD_COMMIT) {
  console.info('[AppleShort build]', process.env.VUE_APP_BUILD_COMMIT)
}

const app = createApp(App)
app.use(store).use(router)
// 图片懒加载，
.use(lazyPlugin, { loading: require('@/assets/images/pic_placeholder.png') })
// 注册loading指令
.directive('loading', loadingDirective)
.directive('touch-db', touchDoubleTap)
.use(createPinia())
.use(ElSlider)
.use(Toast, {
  // 位置：右上角
  position: 'bottom-center',
  // 3秒自动关闭
  timeout: 3000,
  // 点击关闭
  closeOnClick: true,
  // 页面失去焦点时暂停计时
  pauseOnFocusLoss: true,
  // 允许拖拽关闭
  draggable: true,
  showProgressBar: false,
  closeButton: false,
  icon: false,
  hideProgressBar: true
})
.component('svg-icon', SvgIcon)
app.use(i18n)
initFirebaseAnalytics().finally(() => {
  initSecuritySignals()
  app.mount('#app')
})
